import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Shield, User } from "lucide-react";

export function Navbar({ variant = "landing" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header
      data-testid="site-navbar"
      className="w-full border-b border-[#E2E8F0] bg-white/90 backdrop-blur sticky top-0 z-40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-sm bg-[#0A2540] flex items-center justify-center">
            <span className="font-heading text-white text-lg font-bold">S</span>
          </div>
          <div className="leading-tight">
            <div className="font-heading text-[#0A2540] text-lg font-bold tracking-tight">
              SmartNation
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#475569]">
              Portal de Accionistas
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {variant === "landing" && !user && (
            <>
              <Link to="/login" data-testid="nav-login-link">
                <Button
                  variant="default"
                  className="bg-[#0A2540] hover:bg-[#051626] text-white rounded-sm"
                >
                  Ingresar
                </Button>
              </Link>
            </>
          )}

          {user && (
            <div className="flex items-center gap-3">
              <div className="hidden sm:flex items-center gap-2 text-sm">
                {user.role === "admin" ? (
                  <Shield size={16} className="text-[#B4975A]" />
                ) : (
                  <User size={16} className="text-[#B4975A]" />
                )}
                <span className="text-[#0F172A] font-medium">{user.name}</span>
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#475569] border border-[#E2E8F0] px-2 py-0.5 rounded-sm">
                  {user.role === "admin" ? "Admin" : "Accionista"}
                </span>
              </div>
              <Button
                data-testid="logout-button"
                onClick={handleLogout}
                variant="outline"
                className="rounded-sm border-[#E2E8F0]"
              >
                <LogOut size={16} className="mr-2" />
                Salir
              </Button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
